var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.167 0.0001447C21.8449 0.0948756 27.2553 6.24859 30 11.4146C30 11.4146 29.102 13.241 28.1963 14.506C27.758 15.1179 27.297 15.7141 26.8126 16.2907C26.4672 16.7012 26.1104 17.101 25.7403 17.4894C22.4329 20.9628 17.6831 23.554 12.6674 22.548C7.09534 21.4302 2.73204 16.5496 0 11.4146C0 11.4146 0.788161 9.5427 1.69884 8.27962C2.10681 7.71313 2.535 7.1618 2.98339 6.62688C3.32695 6.21702 3.68314 5.81725 4.05132 5.42885C6.97345 2.34947 10.7229 -0.0213276 15.167 0.0001447ZM15.1437 2.5263C11.4239 2.51241 8.33063 4.58954 5.88342 7.16811C5.5506 7.51862 5.22977 7.87986 4.91906 8.24994C4.51045 8.73749 4.12016 9.24082 3.74818 9.75679C3.40463 10.2336 3.08065 10.8967 2.83182 11.3925C5.21462 15.4773 8.69629 19.1749 13.1644 20.0711C17.3092 20.9028 21.1774 18.6179 23.9107 15.7476C24.2448 15.3971 24.5675 15.0352 24.8795 14.6645C25.3216 14.1384 25.7422 13.5947 26.1419 13.0357C26.4937 12.5444 26.8644 11.9198 27.1448 11.4146C24.6547 7.21043 20.4183 2.6084 15.1437 2.5263Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9439 6.3291C17.7385 6.3291 20.0076 8.59822 20.0076 11.3922C20.0076 14.1867 17.7385 16.4552 14.9439 16.4552C12.15 16.4552 9.88086 14.1867 9.88086 11.3922C9.88086 8.59822 12.15 6.3291 14.9439 6.3291ZM14.9439 8.86094C16.3415 8.86094 17.4757 9.99519 17.4757 11.3922C17.4757 12.7897 16.3415 13.924 14.9439 13.924C13.5469 13.924 12.4127 12.7897 12.4127 11.3922C12.4127 9.99519 13.5469 8.86094 14.9439 8.86094Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/Eye_icon.70ed3157bea5970f85e42d83b9bc1e2a.svg";
export { ForwardRef as ReactComponent };